"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelSet = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const Block_1 = require("./Block");
const lock_svg_1 = __importDefault(require("../../assets/svg/lock.svg"));
const pixi_js_1 = require("pixi.js");
const Global_1 = require("../Global");
const i18next_1 = __importDefault(require("i18next"));
const NameBanner_1 = require("./NameBanner");
const settings_1 = require("../config/settings");
const LevelButton_1 = require("./LevelButton");
const levels_1 = require("../../../shared/levels");
const filter = new pixi_js_1.ColorMatrixFilter();
filter.greyscale(0.8, false);
class LevelSet extends Block_1.Block {
    constructor(app, gameManager, level, select, w = app.screen.width) {
        var _a;
        super(app);
        this.gameManager = gameManager;
        this.level = level;
        this.select = select;
        this.w = w;
        this.padding = 5;
        this.lvl = levels_1.levels.indexOf(this.level);
        const enabled = (((_a = this.gameManager.playerManager.data) === null || _a === void 0 ? void 0 : _a.lvl) || 0) >= this.lvl;
        // Make header label
        const txt = i18next_1.default.t('levels.level', { value: level.level });
        this.header = new NameBanner_1.NameBanner(app, txt, level, 110);
        this.header.bottomlayout = false;
        this.header.color = settings_1.Settings.whiteColor;
        if (!enabled) {
            if (this.header.sprite.filters) {
                this.header.sprite.filters.push(filter);
            }
            else {
                this.header.sprite.filters = [filter];
            }
        }
        this.addChild(this.header);
        this.container = new pixi_js_1.Container();
        this.addChild(this.container);
        for (let i = 0; i < level.terms.length; i++) {
            const term = level.terms[i];
            const hasdrawn = this.didDraw(i);
            const color = enabled ? (hasdrawn ? settings_1.Settings.successColor : settings_1.Settings.whiteColor) : settings_1.Settings.disabledColor;
            const textColor = enabled ? (hasdrawn ? settings_1.Settings.whiteColor : settings_1.Settings.blackColor) : settings_1.Settings.disabledColor2;
            const txt = (0, Global_1.category)(term, false);
            const button = new LevelButton_1.LevelButton(this.app, txt, color, textColor);
            const btn = button.asButton(0.01);
            btn.pivot.set(button.width / 2, button.height / 2);
            btn.enabled = enabled;
            if (!enabled) {
                const lk = pixi_js_1.Sprite.from(lock_svg_1.default);
                lk.anchor.set(0.5);
                lk.scale.set((0, Global_1.px)(0.16));
                lk.position = btn.pivot;
                btn.addChild(lk);
            }
            this.container.addChild(btn);
            this.sigs.push(btn.onPress.connect(() => {
                // Enter into the level room
                this.select(term);
            }));
        }
        this.layout();
    }
    didDraw(tidx) {
        var _a;
        const data = this.gameManager.playerManager.data;
        if (data && this.lvl !== -1) {
            if (this.lvl < data.lvl) {
                return true;
            }
            else if (this.lvl > data.lvl) {
                return false;
            }
            else if (this.lvl === data.lvl) {
                return ((_a = data.lvlf) === null || _a === void 0 ? void 0 : _a.indexOf(tidx)) !== -1;
            }
        }
        return false;
    }
    destroy(_options) {
        super.destroy(_options);
    }
    layout() {
        super.layout();
        this.container.children.forEach((btn, i) => {
            var _a;
            (_a = ((btn.getChildAt(0)))) === null || _a === void 0 ? void 0 : _a.layout();
        });
        this.header.position.set(this.w / 2, 0);
        const fits = Math.max(2, Math.min(4, Math.floor((this.w / (0, Global_1.px)()) / (LevelButton_1.LevelButton.w + this.padding * 2))));
        let row = 0;
        if ((0, Global_1.isrtl)()) {
            let col = Math.min(fits - 1, this.level.terms.length - 1);
            for (let i = 0; i < this.level.terms.length; i++) {
                const btn = this.container.getChildAt(i);
                if (btn) {
                    const lb = (btn.getChildAt(0));
                    const ox = col * lb.width;
                    const oy = row * lb.height;
                    const pax = (0, Global_1.px)(this.padding * col);
                    const pay = (0, Global_1.px)(this.padding * row);
                    btn.position.set(ox + lb.width / 2 + pax, oy + lb.height / 2 + pay);
                }
                if (--col < 0) {
                    col = fits - 1;
                    row++;
                }
            }
        }
        else {
            let col = 0;
            for (let i = 0; i < this.level.terms.length; i++) {
                const btn = this.container.getChildAt(i);
                if (btn) {
                    const lb = (btn.getChildAt(0));
                    const ox = col * lb.width;
                    const oy = row * lb.height;
                    const pax = (0, Global_1.px)(this.padding * col);
                    const pay = (0, Global_1.px)(this.padding * row);
                    btn.position.set(ox + lb.width / 2 + pax, oy + lb.height / 2 + pay);
                }
                if (++col >= fits) {
                    col = 0;
                    row++;
                }
            }
        }
        this.container.pivot.set(this.container.width / 2, 0);
        this.container.position.set(this.w / 2, (0, Global_1.px)(28));
    }
}
exports.LevelSet = LevelSet;
